module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Owners","action":{"save":"Save","cancel":"Cancel"},"owners-form":{"ower-label":"Owner","part":"part"}}}')
  delete Component.options._Ctor
}
